import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from 'react-redux';
import { combineReducers } from 'redux';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { reducer as app, epics as appEpics } from '../../models/app';
import { startApplication } from '../../models/app/actions';
import { reducer as ui, epics as uiEpics } from '../../models/ui';
import { reducer as user, epics as userEpics } from '../../models/user';
import configStore from './configStore';
const ModelProvider = ({ options, children }) => {
    const rootReducer = combineReducers({
        ui,
        app,
        user,
    });
    const rootEpic = combineEpics(uiEpics, appEpics, userEpics);
    const epicMiddleware = createEpicMiddleware({
        dependencies: { options },
    });
    const middleWares = [epicMiddleware];
    const store = configStore(rootReducer, {}, middleWares);
    epicMiddleware.run(rootEpic);
    store.dispatch(startApplication());
    return _jsx(Provider, { store: store, children: children });
};
export default ModelProvider;
